import { useEffect, useState } from 'react'
import { fetchLeaderboard } from '../api'

function short(addr) {
  return `${addr.slice(0, 6)}…${addr.slice(-4)}`
}

export default function Leaderboard({ game, accent, playerAddress }) {
  const [entries, setEntries] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    let alive = true
    setEntries(null)
    setError(false)
    fetchLeaderboard(game.id, 10)
      .then((d) => alive && setEntries(d.entries))
      .catch(() => alive && setError(true))
    return () => {
      alive = false
    }
  }, [game.id])

  return (
    <section className="lb">
      <h3 className="lb-title" style={{ color: accent }}>
        HIGH SCORES
      </h3>

      {error && <p className="lb-empty">SCOREBOARD OFFLINE — TRY AGAIN LATER</p>}
      {!error && entries === null && <p className="lb-empty">LOADING…</p>}
      {!error && entries?.length === 0 && (
        <p className="lb-empty">NO SCORES YET — BE THE FIRST</p>
      )}

      {entries?.length > 0 && (
        <ol className="lb-list">
          {entries.map((e) => {
            const isYou =
              playerAddress && e.address === playerAddress.toLowerCase()
            return (
              <li
                key={e.address}
                className={`lb-row${isYou ? ' lb-you' : ''}`}
              >
                <span className="lb-rank">
                  {e.rank === 1 ? '★' : e.rank}
                </span>
                <span className="lb-addr">
                  {short(e.address)}
                  {isYou ? ' (YOU)' : ''}
                </span>
                <span className="lb-score">{e.score}</span>
              </li>
            )
          })}
        </ol>
      )}
    </section>
  )
}
